import axios from 'axios'
import { handleNetworkError } from 'actions/Error'

export function fetchStreetNames(query) {
    return (dispatch, getState) => {
        axios
            .get(
                `${process.env.AH_URL}/${
                    process.env.AH_COUNTRYCODE
                }/streetSearch/${encodeURIComponent(query)}`,
                {
                    params: {
                        apiKey: process.env.AH_API_KEY,
                        limitToOfficial: process.env.AH_LIMIT_TO_OFFICIAL,
                        limit: 50,
                        location: getState().region.slug ? getState().region.slug : null,
                    },
                }
            )
            .then((response) => {
                dispatch({ type: 'FETCH_STREET_ADDRESS_SUCCESS', payload: response })
            })
            .catch((err) => {
                dispatch({ type: 'FETCH_STREET_ADDRESS_FAILED', payload: err })
                dispatch(handleNetworkError(err))
            })
    }
}

export function fetchStreetNumbers(query, streetIds) {
    return (dispatch) => {
        axios
            .get(
                `${process.env.AH_URL}/${
                    process.env.AH_COUNTRYCODE
                }/streetNumberSearch/${streetIds.toString()}`,
                {
                    params: {
                        streetNumber: query,
                        apiKey: process.env.AH_API_KEY,
                        limitToOfficial: process.env.AH_LIMIT_TO_OFFICIAL,
                        limit: 100,
                    },
                }
            )
            .then((response) => {
                dispatch({ type: 'FETCH_STREET_NUMBERS_SUCCESS', payload: response })
            })
            .catch((err) => {
                dispatch({ type: 'FETCH_STREET_NUMBERS_FAILED', payload: err })
                dispatch(handleNetworkError(err))
            })
    }
}

export function fetchFloors(deliveryPointId) {
    return (dispatch) => {
        axios
            .get(
                `${process.env.AH_URL}/${process.env.AH_COUNTRYCODE}/address/${deliveryPointId}/floors`,
                {
                    params: {
                        apiKey: process.env.AH_API_KEY,
                    },
                }
            )
            .then((response) => {
                dispatch({ type: 'FETCH_FLOORS_SUCCESS', payload: response })
            })
            .catch((err) => {
                console.error(err)
                dispatch({ type: 'FETCH_FLOORS_FAILED', payload: err })
                dispatch(handleNetworkError(err))
            })
    }
}

export function fetchHouseholds(deliveryPointId, floorNo, floorType) {
    return (dispatch) => {
        axios
            .get(
                `${process.env.AH_URL}/${process.env.AH_COUNTRYCODE}/address/${deliveryPointId}/floor/${floorType}-${floorNo}/households`,
                {
                    params: {
                        apiKey: process.env.AH_API_KEY,
                    },
                }
            )
            .then((response) => {
                dispatch({ type: 'FETCH_HOUSEHOLDS_SUCCESS', payload: response })
            })
            .catch((err) => {
                dispatch({ type: 'FETCH_HOUSEHOLDS_FAILED', payload: err })
                dispatch(handleNetworkError(err))
            })
    }
}

export function setCO(co) {
    return (dispatch) => {
        dispatch({ type: 'SET_CO', payload: co })
    }
}

export function setStreetAddress(street) {
    return (dispatch) => {
        dispatch({ type: 'SET_STREET_ADDRESS', payload: street })
        dispatch(fetchStreetNumbers('', street.streetIds))
    }
}

export function setStreetNumber(number) {
    return (dispatch) => {
        dispatch({ type: 'SET_STREET_NUMBER', payload: number })
        dispatch(fetchFloors(number.deliveryPointId))
    }
}

export function setFloor(deliveryPointId, floor) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_FLOOR', payload: floor })
        dispatch(
            fetchHouseholds(
                getState().addressHelper.deliveryPointId,
                floor.floorNo,
                floor.floorType
            )
        )
    }
}

export function setHousehold(household) {
    return (dispatch) => {
        dispatch({ type: 'SET_HOUSEHOLD', payload: household })
    }
}

export function searchAddress(query) {
    return (dispatch) => {
        dispatch({ type: 'SEARCH_ADDRESS', payload: query })
    }
}
